// extracted by mini-css-extract-plugin
export default {"container":"ProcessIBAN_container__E3A+J","title":"ProcessIBAN_title__Cn+PD","iframe":"ProcessIBAN_iframe__vXRUu"};